/**
 * Normalizes an email for storage and lookup.
 * - Trims whitespace
 * - Lowercases
 *
 * Throws if input is empty/whitespace-only or not a string. No fallbacks per
 * CLAUDE.md rule #1 — a silent default here would mask auth misconfiguration
 * and allow inconsistent email identities across Cognito + DynamoDB.
 */
export function normalizeEmail(input) {
    if (typeof input !== 'string') {
        throw new Error('normalizeEmail: input must be a string');
    }
    const trimmed = input.trim();
    if (!trimmed) {
        throw new Error('normalizeEmail: email is required');
    }
    return trimmed.toLowerCase();
}
//# sourceMappingURL=normalize-email.js.map